module.exports = __webpack_public_path__ + "img/four.1b71a264.png";